export default class MeigaranewsviewService {
  getAll(params, meigaraCode) {
      const queryParams = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');

      let url = null;
      if (meigaraCode) {
        url = 'https://api.tradersr.com/api/meigaranewsview/' + meigaraCode + '?'
      } else {
        url = 'https://api.tradersr.com/api/meigaranewsview?'
      }

      return fetch(url + queryParams).then(res => res.json())
  }
}